(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8862],{

/***/ 86593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(68693);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(87975));
var _jsxRuntime = __webpack_require__(61250);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
}), 'BugReport');
exports.Z = _default;

/***/ }),

/***/ 13078:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(68693);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(87975));
var _jsxRuntime = __webpack_require__(61250);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
}), 'Security');
exports.Z = _default;

/***/ }),

/***/ 36762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Avatar_Avatar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.22.5/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(99043);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@babel+runtime@7.22.5/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(83027);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+utils@5.13.1_@types+react@17.0.62_react@17.0.2/node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(53664);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(2529);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(57104);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(47826);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/internal/svg-icons/Person.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/avatarClasses.js
var avatarClasses = __webpack_require__(73736);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js


const _excluded = ["alt", "children", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"];









const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0,composeClasses/* default */.Z)(slots, avatarClasses/* getAvatarUtilityClass */.$, classes);
};
const AvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none'
}, ownerState.variant === 'rounded' && {
  borderRadius: (theme.vars || theme).shape.borderRadius
}, ownerState.variant === 'square' && {
  borderRadius: 0
}, ownerState.colorDefault && (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.background.default
}, theme.vars ? {
  backgroundColor: theme.vars.palette.Avatar.defaultBg
} : {
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
})));
const AvatarImg = (0,styled/* default */.ZP)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0,styled/* default */.ZP)(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});
function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = react.useState(false);
  react.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;
    if (srcSet) {
      image.srcset = srcSet;
    }
    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
const Avatar = /*#__PURE__*/react.forwardRef(function Avatar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAvatar'
  });
  const {
      alt,
      children: childrenProp,
      className,
      component = 'div',
      imgProps,
      sizes,
      src,
      srcSet,
      variant = 'circular'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  let children = null;

  // Use a hook instead of onError on the img element to support server-side rendering.
  const loaded = useLoaded((0,esm_extends/* default */.Z)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarImg, (0,esm_extends/* default */.Z)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      ownerState: ownerState,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarFallback, {
      ownerState: ownerState,
      className: classes.fallback
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m["default"])(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = (Avatar);

/***/ }),

/***/ 73736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getAvatarUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13922);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36163);


function getAvatarUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiAvatar', slot);
}
const avatarClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
/* harmony default export */ __webpack_exports__["Z"] = (avatarClasses);

/***/ }),

/***/ 53888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83027);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99043);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14517);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53664);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2529);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57104);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51804);
/* harmony import */ var _cardClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58900);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61250);


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _cardClasses__WEBPACK_IMPORTED_MODULE_3__/* .getCardUtilityClass */ .y, classes);
};
const CardRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Paper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Card(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 58900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getCardUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13922);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36163);


function getCardUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiCard', slot);
}
const cardClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiCard', ['root']);
/* harmony default export */ __webpack_exports__["Z"] = (cardClasses);

/***/ }),

/***/ 35192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83027);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99043);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29901);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14517);
/* harmony import */ var _mui_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53664);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2529);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57104);
/* harmony import */ var _cardContentClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61250);


const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_mui_base__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _cardContentClasses__WEBPACK_IMPORTED_MODULE_3__/* .getCardContentUtilityClass */ .N, classes);
};
const CardContentRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CardContent(inProps, ref) {
  const props = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CardContentRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    as: component,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__["default"])(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (CardContent);

/***/ }),

/***/ 8092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ getCardContentUtilityClass; }
/* harmony export */ });
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13922);
/* harmony import */ var _generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36163);


function getCardContentUtilityClass(slot) {
  return (0,_generateUtilityClass__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('MuiCardContent', ['root']);
/* harmony default export */ __webpack_exports__["Z"] = (cardContentClasses);

/***/ }),

/***/ 27769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createIcon = _interopRequireDefault(__webpack_require__(23082));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _createIcon["default"])('M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63M12,6A6,6 0 0,1 18,12C18,14.22 16.79,16.16 15,17.2V19A1,1 0 0,1 14,20H10A1,1 0 0,1 9,19V17.2C7.21,16.16 6,14.22 6,12A6,6 0 0,1 12,6M14,21V22A1,1 0 0,1 13,23H11A1,1 0 0,1 10,22V21H14M11,18H13V15.87C14.73,15.43 16,13.86 16,12A4,4 0 0,0 12,8A4,4 0 0,0 8,12C8,13.86 9.27,15.43 11,15.87V18Z', 'LightbulbOnOutline');

exports.Z = _default;

/***/ }),

/***/ 10078:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback",
      function () {
        return __webpack_require__(59247);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ feedback; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(26806);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/BugReport.js
var BugReport = __webpack_require__(86593);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Feedback.js
var Feedback = __webpack_require__(13337);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Security.js
var Security = __webpack_require__(13078);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(36762);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mdi-material-ui@7.7.0_@mui+material@5.13.5_react@17.0.2/node_modules/mdi-material-ui/LightbulbOnOutline.js
var LightbulbOnOutline = __webpack_require__(27769);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(21586);
;// CONCATENATED MODULE: ./views/feedback-page.tsx


















var styles = function(theme) {
    return {
        avatar: {
            margin: 10,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main
        },
        flexContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center"
        }, theme.breakpoints.down("sm"), {
            flexWrap: "wrap"
        })
    };
};
var FeedbackPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FeedbackPage, _Component);
    var _super = (0,_create_super/* default */.Z)(FeedbackPage);
    function FeedbackPage() {
        (0,_class_call_check/* default */.Z)(this, FeedbackPage);
        return _super.apply(this, arguments);
    }
    var _proto = FeedbackPage.prototype;
    _proto.render = function render() {
        var _props = this.props, t = _props.t, theme = _props.theme, classes = _props.classes;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            style: {
                marginBottom: 1 / 2
            },
            spacing: 1,
            alignItems: "stretch",
            justifyContent: "flex-start",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 12,
                md: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.flexContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        className: classes.avatar,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h3",
                                        children: t([
                                            "shared:feedback"
                                        ], {
                                            defaultValue: "Feedback"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                style: {
                                    marginBottom: 1 / 2
                                },
                                spacing: 1,
                                alignItems: "stretch",
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "h5",
                                                style: {
                                                    marginTop: theme.spacing(2)
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LightbulbOnOutline/* default */.Z, {
                                                        style: {
                                                            marginRight: "0.25em"
                                                        }
                                                    }),
                                                    t([
                                                        "feedback:ImprovementsAndFeatureRequestsTitle"
                                                    ], {
                                                        defaultValue: "Improvements & Feature Requests"
                                                    })
                                                ]
                                            }),
                                            t([
                                                "feedback:ImprovementsAndFeatureRequestsText"
                                            ], {
                                                defaultValue: "We are always looking for ways to improve Factbird with enhancements and new features. A core part of our culture at Factbird is to listen carefully to the feedback that we get so we can focus on the things that add value for you. We are always open to hearing suggestions, so feel free to submit your feedback at support@factbird.com, and we will get back to you."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "h5",
                                                style: {
                                                    marginTop: theme.spacing(2)
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BugReport/* default */.Z, {}),
                                                    " ",
                                                    t([
                                                        "feedback:bugReportsTitle"
                                                    ], {
                                                        defaultValue: "Bug Reports"
                                                    })
                                                ]
                                            }),
                                            t([
                                                "feedback:bugReportsText"
                                            ], {
                                                defaultValue: "Factbird is continuously improving and pushing the limits of what is capable. We place a high value on delivering quality features and the best experience. Unfortunately, sometimes a mistake slips through our automated and manual quality assurance processes. If you spot a bug, please reach out to us to fix it as quickly as possible. A good bug report contains the following elements:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: t([
                                                            "feedback:bugReportsListSummery"
                                                        ], {
                                                            defaultValue: "A description of the issue."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: t([
                                                            "feedback:bugReportsListStepsToReproduce"
                                                        ], {
                                                            defaultValue: "Steps to reproduce the bug. Please include which browser you are using and if possible the version."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: t([
                                                            "feedback:bugReportsListExpectedResult"
                                                        ], {
                                                            defaultValue: "What did you expect to happen?"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: t([
                                                            "feedback:bugReportsListActualResults"
                                                        ], {
                                                            defaultValue: "What happened instead? Screenshots can be very helpful!"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: t([
                                                            "feedback:bugReportsListImpact"
                                                        ], {
                                                            defaultValue: "What is the impact of the bug to you?"
                                                        })
                                                    })
                                                ]
                                            }),
                                            t([
                                                "feedback:bugReportsTextEnd"
                                            ], {
                                                defaultValue: "Bug reports can be submitted by email to support@factbird.com with the subject starting with 'Bug Report: '."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        md: 6,
                                        lg: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "h5",
                                                style: {
                                                    marginTop: theme.spacing(2)
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Security/* default */.Z, {}),
                                                    " ",
                                                    t([
                                                        "feedback:securityReportsTitle"
                                                    ], {
                                                        defaultValue: "Security Reports"
                                                    })
                                                ]
                                            }),
                                            t([
                                                "feedback:securityReportsText"
                                            ], {
                                                defaultValue: "We care deeply about security at Factbird. If you suspect you might have found a security issue, please reach out to us immediately at support@factbird.com so we can fix it immediately! If you start the subject with 'Security/Abuse Report: ' we can make sure to prioritize it as quickly as possible. We kindly ask you to follow standard disclosure protocols and not publicly disclose a vulnerability until we have released a fix. Please do not attempt to carry out Denial-of-Service attacks. We also discourage the use of any vulnerability testing tools that automatically generate very significant volumes of traffic."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    return FeedbackPage;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "feedback"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var feedback_page = (enhance(FeedbackPage));

;// CONCATENATED MODULE: ./pages/feedback/index.tsx


var feedback_Feedback = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(feedback_page, {});
};
var __N_SSG = true;
/* harmony default export */ var feedback = (feedback_Feedback);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(10078); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);